import { render, staticRenderFns } from "./stop-resume-lawsuit-request.vue?vue&type=template&id=74de762e&scoped=true&"
import script from "./stop-resume-lawsuit-request.vue?vue&type=script&lang=js&"
export * from "./stop-resume-lawsuit-request.vue?vue&type=script&lang=js&"
import style0 from "./stop-resume-lawsuit-request.vue?vue&type=style&index=0&id=74de762e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de762e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
